(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    if (location.pathname.includes("/products/") && location.pathname.includes("-outlet")) return;
    
    addStyle();
    if (location.pathname.includes("/products/")) {
      addCompareBtnPDP();
    } else if (location.pathname.includes("/collections/")) {
      addCompareBtn();
    }
    addPopup();
    updateAll();
    assignCssVariables();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.compare_fridge_popup.show) {
        overflow: hidden;
      }

      .itemsCategoryWrapper {
        position: relative;
      }
      .btn-compare_fridge {
        width: 100%;
        margin-bottom: 1rem;
        padding: 12px;
        background: #fff;
        border: 2px solid #7A0000;
        color: #7A0000;
        font-weight: 700;
      }
      .btn-compare_fridge:active {
        transform: scale(0.98);
      }
      .compare_fridge_popup {
        display: none;
        position: fixed;
        top: 72px;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        overflow-y: auto;
        z-index: 9999999;
      }
      .compare_fridge_popup p {
        margin: 0;
      }
      .compare_fridge_popup_close_btn {
        display: block;
        position: sticky;
        top: 10px;
        right: 10px;
        width: fit-content;
        margin-left: auto;
        background: none repeat scroll 0 0 transparent;
        border: medium none;
        border-spacing: 0;
        cursor: pointer;
        z-index: 2;
      }
      .compare_fridge_popup_close_btn svg.icon-close {
        width: 25px;
        height: 25px;
      }
      .compare_fridge_popup .container_title {
        padding-bottom: 12px;
        font-weight: 700;
        font-size: 28px;
        text-align: center;
      }
      .compare_fridge_popup .container_subtitle {
        margin-bottom: 1rem;
        text-align: center;
        font-size: 14px;
      }

      /* Table */
      .compare_fridge_popup .compare_list table {
        width: 100%;
        table-layout: fixed;
      }
      .compare_fridge_popup .compare_list table tr {
        background: #fff;
      }
      .compare_fridge_popup .compare_list table tr > *:nth-child(3) {
        display: none;
      }
      .compare_fridge_popup .compare_list table tr:has(th.row_header) {
        border-bottom: 1px solid black;
      }
      .compare_fridge_popup .compare_list table th.row_header {
        font-size: 26px;
        font-weight: 700;
      }
      .compare_fridge_popup .compare_list table th {
        padding: 1rem 3px 0px;
      }
      .compare_fridge_popup .compare_list table td {
        padding: 0px 3px;
        vertical-align: top;
      }
      @media (min-width: 1024px) {
        .compare_fridge_popup .compare_list table tr > *:nth-child(3) {
          display: table-cell;
        }
        .compare_fridge_popup .compare_list table th.row_header {
          font-size: 32px;
        }
        .compare_fridge_popup .compare_list table th,
        .compare_fridge_popup .compare_list table td {
          padding-inline: 8px;
        }
      }

      .compare_fridge_popup .compare_list table tr.row_select {
        position: sticky;
        top: 0px;
        z-index: 1;
      }
      .compare_fridge_popup .compare_list table tr.row_variant {
        position: sticky;
        top: 85px;
      }
      .compare_fridge_popup .compare_list table tr.row_price {
        position: sticky;
        top: 148px;
      }
      .compare_fridge_popup .compare_list table tr.row_cta {
        position: sticky;
        top: 190px;
        box-shadow: 0px 4px 2px -2px #00000040;
      }
      .compare_fridge_popup .compare_list table tr.row_select td,
      .compare_fridge_popup .compare_list table tr.row_variant td,
      .compare_fridge_popup .compare_list table tr.row_price td,
      .compare_fridge_popup .compare_list table tr.row_cta td {
        padding-block: 0.5rem;
      }
      .compare_fridge_popup .compare_list table .row_image .image_wrapper img {
        max-height: 330px;
        width: auto;
        display: block;
        margin: 0 auto;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        text-align: center;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper .variant_options {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        gap: 8px;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper .variant_options .variant_option {
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #000;
        border-radius: 100%;
        cursor: pointer;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper .variant_options .variant_option.selected:after {
        position: absolute;
        top: -4px;
        left: -4px;
        content: "";
        width: 26px;
        height: 26px;
        border-radius: 100%;
        border: 1px solid #000;
      }
      .compare_fridge_popup .compare_list table .row_price .price_wrapper {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      .compare_fridge_popup .compare_list table .row_price .price_wrapper .price {
        color: #9b0202;
        font-size: 17px;
        font-weight: 700;
      }
      .compare_fridge_popup .compare_list table .row_price .price_wrapper .compare_at_price {
        font-size: 13px;
        align-self: flex-end;
      }
      .compare_fridge_popup .compare_list table .row_cta .cta_wrapper {
        width: 100%;
      }
      .compare_fridge_popup .compare_list table .row_cta .cta_wrapper a {
        width: 100%;
        padding: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7a0000;
        background: #7a0000;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
      }
      @media (min-width: 1024px) {
        .compare_fridge_popup .compare_list table .row_price .price_wrapper .price {
          font-size: 22px;
        }
        .compare_fridge_popup .compare_list table .row_cta .cta_wrapper a {
          padding: 13px 23px;
          font-size: 16px;
        }
      }

      /* Select */
      .compare_fridge_popup .select {
        position: relative;
        width: 100%;
      }
      .compare_fridge_popup .select .trigger {
        display: flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        background-color: #fff;
        border: 1.5px solid #e8e9eb;
        border-radius: 2px;
        padding: 1rem 2rem 1rem 1rem;
        height: 70px;
        font-weight: 600;
      }
      .compare_fridge_popup .select .trigger:after {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/c436165bf05bba37de8351ac6640ef40.svg) no-repeat center;
        background-size: cover;
        width: 14px;
        height: 7px;
        content: "";
      }
      .compare_fridge_popup .select .trigger span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .compare_fridge_popup .select .options {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        left: 0;
        max-height: 320px;
        border-radius: 4px;
        background: #676669;
        padding: 10px 0;
        overflow-y: auto;
        z-index: 1;
      }
      .compare_fridge_popup .select.open .options {
        display: block;
      }
      .compare_fridge_popup .select .options .option {
        position: relative;
        cursor: pointer;
        padding: 3px 42px;
        color: #fff;
        line-height: 1.7;
      }
      .compare_fridge_popup .select .options .option:hover {
        background: #4687e9;
      }
      .compare_fridge_popup .select .options .option.selected:before {
        display: block;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/85a786792f447dd5bad3b7b35c183ac9.svg) no-repeat center;
        background-size: cover;
        width: 18px;
        height: 17px;
        content: "";
      }
      @media (min-width: 1024px) {
        .compare_fridge_popup .select .trigger {
          padding: 1rem 3rem 1rem 1rem;
        }
      }

      @media (min-width: 1024px) {
        .btn-compare_fridge {
          position: absolute;
          top: 0;
          right: 0;
          max-width: 180px;
          margin-bottom: 0;
        }
        .compare_fridge_popup {
          top: var(--nav-height, 86.87px);
        }
        .compare_fridge_popup_close_btn {
          top: 22px;
          right: 22px;
        }
        .compare_fridge_popup .container_title {
          font-size: 33px;
        }
        .compare_fridge_popup .container_subtitle {
          font-size: 16px;
        }
      }
      @media (max-width: 1023px) {
        .tv_compare_popup [data-index="3"] {
          display: none;
        }
      }
    `;
    document.head.append(style);
  }

  function addCompareBtn() {
    const button = document.createElement("button");
    button.classList.add("btn-compare_fridge");
    button.textContent = "Compare Fridges";
    button.addEventListener("click", function () {
      $(".compare_fridge_popup").addClass("show");
    });
    const firstSection = $(".itemsCategoryWrapper").first();
    firstSection.prepend(button);
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");
    button.classList.add("btn", "spec-button");
    button.textContent = "Compare";
    button.addEventListener("click", function () {
      $(".compare_fridge_popup").toggleClass("show");
    });
    $(".nav2-content").prepend(button);
  }

  function addPopup() {
    const popup = document.createElement("div");
    popup.classList.add("compare_fridge_popup");

    const closeBtn = document.createElement("button");
    closeBtn.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"></path></svg>`;
    closeBtn.classList.add("compare_fridge_popup_close_btn");
    closeBtn.addEventListener("click", function () {
      $(".compare_fridge_popup").removeClass("show");
    });

    const container = document.createElement("div");
    container.classList.add("compare_fridge_popup_container");
    container.innerHTML = `
      <div class="page-width">
        <div class="container_title">Compare Fridges</div>
        <div class="container_subtitle">Your fridge isn’t just an appliance — it’s the heart of your kitchen. Find the ideal match for your lifestyle and enjoy freshness that lasts!</div>
        <div class="compare_list"></div>
      </div>
    `;

    const table = document.createElement("table");

    const row_fridges = getRows_Fridges();
    const row_physical_characteristics = getRows_PhysicalCharacteristics();
    const row_performance = getRows_Performance();
    const row_storage = getRows_Storage();
    const row_controls = getRows_Controls();
    const row_design_build = getRows_DesignBuild();

    for (const row of row_fridges) {
      table.append(row);
    }
    for (const row of row_physical_characteristics) {
      table.append(row);
    }
    for (const row of row_performance) {
      table.append(row);
    }
    for (const row of row_storage) {
      table.append(row);
    }
    for (const row of row_controls) {
      table.append(row);
    }
    for (const row of row_design_build) {
      table.append(row);
    }
    container.querySelector(".compare_list").append(table);

    popup.append(closeBtn, container);
    document.body.append(popup);
  }

  function getRows_Fridges() {
    let returnValue = [];

    const rowSelect = document.createElement("tr");
    const rowImage = document.createElement("tr");
    const rowVariant = document.createElement("tr");
    const rowPrice = document.createElement("tr");
    const rowCta = document.createElement("tr");

    rowSelect.classList.add("row_select");
    rowImage.classList.add("row_image");
    rowVariant.classList.add("row_variant");
    rowPrice.classList.add("row_price");
    rowCta.classList.add("row_cta");

    function getFridgeDropdown(index = 0) {
      const select = document.createElement("div");
      select.classList.add("select");

      const data = getDetails();

      const trigger = document.createElement("div");
      trigger.classList.add("trigger");
      //trigger.innerHTML = `<span>${data[index].name}</span>`;
      trigger.innerHTML = `<span>${data[index].name.replace(/\s*\([^)]*\)\s*$/, "")}</span>`;

      const options = document.createElement("div");
      options.classList.add("options");
      data.forEach((x, i) => {
        const option = document.createElement("div");
        option.classList.add("option");
        if (i == index) option.classList.add("selected");
        //option.textContent = x.name;
        option.textContent = x.name.replace(/\s*\([^)]*\)\s*$/, "");
        option.setAttribute("data-handle", x.handle);
        options.append(option);

        option.addEventListener("click", function () {
          $(this).siblings(".option").removeClass("selected");
          $(this).addClass("selected");
          //$(this).closest(".select").find(".trigger span").text($(this).text());
          $(this)
            .closest(".select")
            .find(".trigger span")
            .text(x.name.replace(/\s*\([^)]*\)\s*$/, ""));
          updateProduct(index, x.handle);
        });
      });

      select.addEventListener("click", function () {
        $(this).toggleClass("open");
      });

      select.append(trigger, options);
      return select;
    }

    for (const x of Array(3).keys()) {
      const cellSelect = document.createElement("td");
      const cellImage = document.createElement("td");
      const cellVariant = document.createElement("td");
      const cellPrice = document.createElement("td");
      const cellCta = document.createElement("td");

      const select = getFridgeDropdown(x);
      cellSelect.append(select);

      const imageWrapper = document.createElement("div");
      imageWrapper.classList.add("image_wrapper");
      imageWrapper.innerHTML = `
        <img src="" alt="" width="" height="" />
      `;
      cellImage.append(imageWrapper);

      const variantWrapper = document.createElement("div");
      variantWrapper.classList.add("variant_wrapper");
      variantWrapper.innerHTML = `
        <p>Available Color Options</p>
        <ul class="variant_options"></ul>
      `;
      cellVariant.append(variantWrapper);

      const priceWrapper = document.createElement("div");
      priceWrapper.classList.add("price_wrapper");
      priceWrapper.innerHTML = `
        <img width="20" height="20" src="//prismplus.sg/cdn/shop/t/35/assets/voucher-icon.svg?v=96074962922774460831765247161" />
        <span class="price">$XXX</span>
        <s class="compare_at_price">$XXX</s>
      `;
      cellPrice.append(priceWrapper);

      const ctaWrapper = document.createElement("div");
      ctaWrapper.classList.add("cta_wrapper");
      ctaWrapper.innerHTML = `<a href="#/">Shop XXX</a>`;
      cellCta.append(ctaWrapper);

      rowSelect.append(cellSelect);
      rowImage.append(cellImage);
      rowVariant.append(cellVariant);
      rowPrice.append(cellPrice);
      rowCta.append(cellCta);
    }

    returnValue.push(rowSelect, rowImage, rowVariant, rowPrice, rowCta);
    return returnValue;
  }

  function getRows_PhysicalCharacteristics() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Physical Characteristics</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Total Gross Capacity",
      "Total Net Capacity",
      "Net Fridge Capacity",
      "Net Freezer Capacity",
      "Type",
      "Product Dimension (L×D×H)",
      "Packing Dimension (L×D×H)",
      "Net Weight",
      "Gross Weight",
    ];

    const detailHeadersAlt = [
      "total_gross_capacity",
      "total_net_capacity",
      "net_fridge_capacity",
      "net_freezer_capacity",
      "type",
      "product_dimension",
      "packing_dimension",
      "net_weight",
      "gross_weight",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");
      
      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_Performance() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Performance</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Compressor",
      "Refrigerant",
      "Muti-Zone Cooling",
      "No Frost Technology",
      "Defrosting System ",
      "Noise Level",
      "Anti Odour",
      "EverCool Thermal Panel",
      "Premium Ceramic Air Filters",
      "Voltage",
    ];

    const detailHeadersAlt = [
      "compressor",
      "refrigerant",
      "multi_zone_cooling",
      "no_frost_technology",
      "defrosting_system",
      "noise_level",
      "anti_odour",
      "evercool_thermal_panel",
      "premium_ceramic_air_filters",
      "voltage",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_Storage() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Storage</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Fridge Tempered Glass shelf",
      "Crisper drawer",
      "Fridge Transparent Door Basket",
      "Twist Ice Maker",
      "Freezer Tempered Glass shelf",
      "Freezer Transparent Door Basket ",
      "Freezer Tray",
      "Freezer Drawer",
    ];

    const detailHeadersAlt = [
      "fridge_tempered_glass_shelf",
      "crisper_drawer",
      "fridge_transparent_door_basket",
      "twist_ice_maker",
      "freezer_tempered_glass_shelf",
      "freezer_transparent_door_basket",
      "freezer_tray",
      "freezer_drawer",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_Controls() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Controls</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Fridge Temperature",
      "Freezer Temperature",
      "External LED Display",
      "Quick Freeze Mode",
      "Quick Cool Mode",
      "Energy Saving Mode",
      "Lock Mode",
    ];

    const detailHeadersAlt = [
      "fridge_temperature",
      "freezer_temperature",
      "external_led_display",
      "quick_freeze_mode",
      "quick_cool_mode",
      "energy_saving_mode",
      "lock_mode",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_DesignBuild() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Design Build</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Door Panel Material",
      "Colours",
      "Handle Type",
      "Wheel",
      "Adjustable leg",
    ];

    const detailHeadersAlt = [
      "door_panel_material",
      "colours",
      "handle_type",
      "wheel",
      "adjustable_leg",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function updateAll() {
    for (const x of Array(3).keys()) {
      updateProduct(x);
    }
  }

  async function updateProduct(index, handle = null) {
    const table = $(".compare_fridge_popup table");

    const cellSelect = table.find(`.row_select > td:nth-child(${index + 1})`);
    const cellImage = table.find(`.row_image > td:nth-child(${index + 1})`);
    const cellVariant = table.find(`.row_variant > td:nth-child(${index + 1})`);
    const cellPrice = table.find(`.row_price > td:nth-child(${index + 1})`);
    const cellCta = table.find(`.row_cta > td:nth-child(${index + 1})`);

    const prodHandle =
      handle ?? cellSelect.find(".select .option.selected").attr("data-handle");
    const prodSelectTitle = cellSelect.find(".select .option.selected").html();
    console.log(prodSelectTitle)
    if (!prodHandle) {
      console.error("Product handle not found.");
      return;
    }
    const productData = await getProductData(prodHandle);
    console.log(productData)
    const availableVariants = productData.variants.filter(
      // (x) => x.available && x.price > 0,
      (x) => x.price > 0,
    );

    var defaultVariant = availableVariants[0];

    const imageWrapper = cellImage.find(".image_wrapper");
    const variantWrapper = cellVariant.find(".variant_wrapper");
    const priceWrapper = cellPrice.find(".price_wrapper");
    const ctaWrapper = cellCta.find(".cta_wrapper");

    if (productData.featured_image) {
      imageWrapper.find("img").attr("src", productData.featured_image);
      imageWrapper.find("img").attr("alt", productData.title);
    }

    variantWrapper.find(".variant_options").empty();
    var j = 0;
    for (const [i, v] of availableVariants.entries()) {
      const variantOption = document.createElement("li");
      var v_title = v.title.trim().toLowerCase().replace(/\s+/g, '-');
      
      console.log(i)
      if(prodSelectTitle.trim() == "PureFresh TMF 250") {
        if (v.option1 == "TMF250L") {
          v_title = v.option2.trim().toLowerCase().replace(/\s+/g, '-');
          if(j == 0) {
            defaultVariant = v
            variantOption.classList.add("selected");
            if (v.featured_image?.src) {
              imageWrapper.find("img").attr("src", v.featured_image.src);
            }
          }
          j++;
        }
        else {
          j = 0;
          continue;
        }
      }
      else if(prodSelectTitle.trim() == "PureFresh TMF 310") {
        if (v.option1 == "TMF310L") {
          v_title = v.option2.trim().toLowerCase().replace(/\s+/g, '-');
          if(j == 0) {
            defaultVariant = v
            variantOption.classList.add("selected");
            if (v.featured_image?.src) {
              imageWrapper.find("img").attr("src", v.featured_image.src);
            }
          }
          j++;
        }
        else {
          j = 0;
          continue;
        }
      }
      else if(prodSelectTitle.trim() == "PureFresh TMF 430") {
        if (v.option1 == "TMF430L") {
          v_title = v.option2.trim().toLowerCase().replace(/\s+/g, '-');
          if(j == 0) {
            defaultVariant = v
            variantOption.classList.add("selected");
            if (v.featured_image?.src) {
              imageWrapper.find("img").attr("src", v.featured_image.src);
            }
          }
          j++;
        }
        else {
          j = 0;
          continue;
        }
      }
      else if(prodSelectTitle.trim() == "FreezeMaster 260") {
        if (v.option1 == "CFZ260L") {
          v_title = v.option2.trim().toLowerCase().replace(/\s+/g, '-');
          if(j == 0) {
            defaultVariant = v
            variantOption.classList.add("selected");
            if (v.featured_image?.src) {
              imageWrapper.find("img").attr("src", v.featured_image.src);
            }
          }
          j++;
        }
        else {
          j = 0;
          continue;
        }
      }
      else if(prodSelectTitle.trim() == "FreezeMaster 390") {
        if (v.option1 == "CFZ390L") {
          v_title = v.option2.trim().toLowerCase().replace(/\s+/g, '-');
          if(j == 0) {
            defaultVariant = v
            variantOption.classList.add("selected");
            if (v.featured_image?.src) {
              imageWrapper.find("img").attr("src", v.featured_image.src);
            }
          }
          j++;
        }
        else {
          j = 0;
          continue;
        }
      }
      variantOption.classList.add(
        "variant_option",
        `variant-${v_title}`,
      );
      if (i == 0) {
        variantOption.classList.add("selected");
        if (v.featured_image?.src) {
          imageWrapper.find("img").attr("src", v.featured_image.src);
        }
      }

      variantOption.addEventListener("click", function () {
        $(this).siblings(".variant_option").removeClass("selected");
        $(this).addClass("selected");
        if (v.featured_image?.src) {
          imageWrapper.find("img").attr("src", v.featured_image.src);
        }

        priceWrapper.find(".price").text(theme.Currency.formatMoney(v.price));
        priceWrapper
          .find(".compare_at_price")
          .text(theme.Currency.formatMoney(v.compare_at_price));
      });
      console.log(variantOption)
      variantWrapper.find(".variant_options").append(variantOption);
    }

    priceWrapper
      .find(".price")
      .text(theme.Currency.formatMoney(defaultVariant.price));
    priceWrapper
      .find(".compare_at_price")
      .text(theme.Currency.formatMoney(defaultVariant.compare_at_price));

    ctaWrapper.find("a").attr("href", `/products/${productData.handle}`);
    ctaWrapper
      .find("a")
      .text(`Shop ${productData.title.replaceAll("PRISM+", "")}`);

    const details = getDetails();
    const curDetails = details.find((x) => x.name == prodSelectTitle);
    const curColumns = table.find(`td:nth-child(${index + 1})`);

    // Physical Characteristics
    curColumns
      .find("p.total_gross_capacity")
      .text(curDetails.physical_characteristics.total_gross_capacity);
    curColumns
      .find("p.total_net_capacity")
      .text(curDetails.physical_characteristics.total_net_capacity);
    curColumns
      .find("p.net_fridge_capacity")
      .text(curDetails.physical_characteristics.net_fridge_capacity);
    curColumns
      .find("p.net_freezer_capacity")
      .text(curDetails.physical_characteristics.net_freezer_capacity);
    curColumns.find("p.type").text(curDetails.physical_characteristics.type);
    curColumns
      .find("p.product_dimension")
      .text(curDetails.physical_characteristics.product_dimension);
    curColumns
      .find("p.packing_dimension")
      .text(curDetails.physical_characteristics.packing_dimension);
    curColumns
      .find("p.net_weight")
      .text(curDetails.physical_characteristics.net_weight);
    curColumns
      .find("p.gross_weight")
      .text(curDetails.physical_characteristics.gross_weight);

    // Performance
    curColumns.find("p.compressor").text(curDetails.performance.compressor);
    curColumns.find("p.refrigerant").text(curDetails.performance.refrigerant);
    curColumns
      .find("p.multi_zone_cooling")
      .text(curDetails.performance.multi_zone_cooling);
    curColumns
      .find("p.no_frost_technology")
      .text(curDetails.performance.no_frost_technology);
    curColumns
      .find("p.defrosting_system")
      .text(curDetails.performance.defrosting_system);
    curColumns.find("p.noise_level").text(curDetails.performance.noise_level);
    curColumns.find("p.anti_odour").text(curDetails.performance.anti_odour);
    curColumns.find("p.evercool_thermal_panel").text(curDetails.performance.evercool_thermal_panel);
    curColumns
      .find("p.premium_ceramic_air_filters")
      .text(curDetails.performance.premium_ceramic_air_filters);
    curColumns
      .find("p.voltage")
      .text(curDetails.performance.voltage);

    // Storage
    curColumns
      .find("p.fridge_tempered_glass_shelf")
      .text(curDetails.storage.fridge_tempered_glass_shelf);
    curColumns.find("p.crisper_drawer").text(curDetails.storage.crisper_drawer);
    curColumns
      .find("p.fridge_transparent_door_basket")
      .text(curDetails.storage.fridge_transparent_door_basket);
    curColumns
      .find("p.twist_ice_maker")
      .text(curDetails.storage.twist_ice_maker);
    curColumns
      .find("p.freezer_tempered_glass_shelf")
      .text(curDetails.storage.freezer_tempered_glass_shelf);
    curColumns
      .find("p.freezer_transparent_door_basket")
      .text(curDetails.storage.freezer_transparent_door_basket);
    curColumns.find("p.freezer_tray").text(curDetails.storage.freezer_tray);
    curColumns.find("p.freezer_drawer").text(curDetails.storage.freezer_drawer);

    // Controls
    curColumns
      .find("p.fridge_temperature")
      .text(curDetails.controls.fridge_temperature);
    curColumns
      .find("p.freezer_temperature")
      .text(curDetails.controls.freezer_temperature);
    curColumns
      .find("p.external_led_display")
      .text(curDetails.controls.external_led_display);
    curColumns.find("p.quick_freeze_mode").text(curDetails.controls.quick_freeze_mode);
    curColumns.find("p.quick_cool_mode").text(curDetails.controls.quick_cool_mode);
    curColumns.find("p.energy_saving_mode").text(curDetails.controls.energy_saving_mode);
    curColumns.find("p.lock_mode").text(curDetails.controls.lock_mode);

    // Design Build
    curColumns
      .find("p.door_panel_material")
      .text(curDetails.design_build.door_panel_material);
    curColumns.find("p.colours").text(curDetails.design_build.colours);
    curColumns.find("p.handle_type").text(curDetails.design_build.handle_type);
    curColumns.find("p.wheel").text(curDetails.design_build.wheel);
    curColumns
      .find("p.adjustable_leg")
      .text(curDetails.design_build.adjustable_leg);
  }

  function getDetails() {
    const data = [
      {
        name: "PureFresh FDR 520",
        handle: "purefresh-fdr-520",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "520L",
          total_net_capacity: "426L",
          net_fridge_capacity: "284L",
          net_freezer_capacity: "142L",
          type: "Four Door",
          product_dimension: "830 x 672 x 1809mm",
          packing_dimension: "884 x 710 x 1891mm",
          net_weight: "80kg",
          gross_weight: "87kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "N/A",
          anti_odour: "N/A",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "220-240V",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "4",
          twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "0",
          freezer_transparent_door_basket: "0",
          freezer_tray: "2",
          freezer_drawer: "4",
        },
        controls: {
          fridge_temperature: "2°C to 9°C",
          freezer_temperature: "-15°C to -24°C",
          external_led_display: "Yes",
          quick_freeze_mode: "Accelerate to -30°C",
          quick_cool_mode: "Accelerate to 2°C",
          energy_saving_mode: "Yes",
          lock_mode: "Yes",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Gentle Matte Black",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "PureFresh FDR 580",
        handle: "purefresh-fdr-580",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "580L",
          total_net_capacity: "474L",
          net_fridge_capacity: "304L",
          net_freezer_capacity: "170L",
          type: "Four Door",
          product_dimension: "830 x 647 x 1822mm",
          packing_dimension: "886 x 695 x 1910mm",
          net_weight: "76kg",
          gross_weight: "84kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "50dB",
          anti_odour: "N/A",
          evercool_thermal_panel: "Yes",
          premium_ceramic_air_filter: "Yes",
          voltage: "220-240V",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "4",
          twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "0",
          freezer_transparent_door_basket: "0",
          freezer_tray: "2",
          freezer_drawer: "4",
        },
        controls: {
          fridge_temperature: "2°C to 9°C",
          freezer_temperature: "-15°C to -24°C",
          external_led_display: "Yes",
          quick_freeze_mode: "Accelerate to -30°C",
          quick_cool_mode: "Accelerate to 2°C",
          energy_saving_mode: "Yes",
          lock_mode: "Yes",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Gentle Matte Black",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "PureFresh FDR 700",
        handle: "purefresh-fdr-700",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "700L",
          total_net_capacity: "546L",
          net_fridge_capacity: "362L",
          net_freezer_capacity: "184L",
          type: "Four Door",
          product_dimension: "830 x 718 x 1891mm",
          packing_dimension: "886 x 772 x 1989mm",
          net_weight: "97kg",
          gross_weight: "105kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "50dB",
          anti_odour: "N/A",
          evercool_thermal_panel: "Yes",
          premium_ceramic_air_filter: "Yes",
          voltage: "220-240V",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "4",
          twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "0",
          freezer_transparent_door_basket: "0",
          freezer_tray: "2",
          freezer_drawer: "4",
        },
        controls: {
          fridge_temperature: "2°C to 9°C",
          freezer_temperature: "-15°C to -24°C",
          external_led_display: "Yes",
          quick_freeze_mode: "Accelerate to -30°C",
          quick_cool_mode: "Accelerate to 2°C",
          energy_saving_mode: "Yes",
          lock_mode: "Yes",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Gentle Matte Black",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "Inspire 720",
        handle: "inspire-720",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "720L",
          total_net_capacity: "569L",
          net_fridge_capacity: "365L",
          net_freezer_capacity: "204L",
          type: "Four Door",
          product_dimension: "911 x 706 x 1830mm",
          packing_dimension: "968 x 750 x 1870mm",
          net_weight: "99kg",
          gross_weight: "108kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "37dB",
          anti_odour: "Yes",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "6",
          twist_ice_maker: "Yes (Removable)",
          freezer_tempered_glass_shelf: "0",
          freezer_transparent_door_basket: "0",
          freezer_tray: "2",
          freezer_drawer: "4 deep drawers",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "-15°C to -23°C",
          external_led_display: "Yes",
          quick_freeze_mode: "Runs for 24hrs or until reaches -28°C",
          quick_cool_mode: "Fridge 2°C for 150mins",
          energy_saving_mode: "Yes",
          lock_mode: "Yes",
        },
        design_build: {
          door_panel_material: "Matte Glass (AG Glass)",
          colours: "Matte White, Matte Black, Sky Blue, Pastel Pink, Pastel Beige",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
        
      },
      {
        name: "PureFresh SBS 720",
        handle: "purefresh-sbs-720",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "720L",
          total_net_capacity: "584L",
          net_fridge_capacity: "355L",
          net_freezer_capacity: "229L",
          type: "Side By Side",
          product_dimension: "910 x 700 x 1866mm",
          packing_dimension: "981 x 764 x 1914mm",
          net_weight: "84kg",
          gross_weight: "92kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "50dB",
          anti_odour: "N/A",
          evercool_thermal_panel: "Yes",
          premium_ceramic_air_filter: "Yes",
          voltage: "220-240V",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "3",
          twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "0",
          freezer_transparent_door_basket: "0",
          freezer_tray: "4",
          freezer_drawer: "2",
        },
        controls: {
          fridge_temperature: "2°C to 9°C",
          freezer_temperature: "-15°C to -24°C",
          external_led_display: "Yes",
          quick_freeze_mode: "Accelerate to -30°C",
          quick_cool_mode: "Accelerate to 2°C",
          energy_saving_mode: "Yes",
          lock_mode: "Yes",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Gentle Matte Black",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "2",
        },
        
      },
      {
        name: "Inspire 750",
        handle: "inspire-750",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "750L",
          total_net_capacity: "627L",
          net_fridge_capacity: "407L",
          net_freezer_capacity: "220L",
          type: "Side By Side",
          product_dimension: "911 x 733 x 1780mm",
          packing_dimension: "968 x 790 x 1845mm",
          net_weight: "95kg",
          gross_weight: "105kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "38dB",
          anti_odour: "Yes",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "4",
          twist_ice_maker: "Yes (Removable)",
          freezer_tempered_glass_shelf: "4",
          freezer_transparent_door_basket: "4",
          freezer_tray: "2",
          freezer_drawer: "2",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "-15°C to -23°C",
          external_led_display: "Yes",
          quick_freeze_mode: "Quick Freeze: Runs for 24hrs or until reaches -28°C",
          quick_cool_mode: "Holiday Mode: SMART: Fridge 5°C, Freezer -18°C",
          energy_saving_mode: "Yes",
          lock_mode: "Yes",
        },
        design_build: {
          door_panel_material: "Matte Glass (AG Glass)",
          colours: "Matte White, Matte Black, Sky Blue, Pastel Pink, Pastel Beige",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
        
      },
      {
        name: "PureFresh TMF 170",
        handle: "purefresh-tmf-170",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "170L",
          total_net_capacity: "125L",
          net_fridge_capacity: "92L",
          net_freezer_capacity: "33L",
          type: "Top Mount",
          product_dimension: "480 x 490 x 1120mm",
          packing_dimension: "510 x 535 x 1210mm",
          net_weight: "28kg",
          gross_weight: "30kg",
        },
        performance: {
          compressor: "Non Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "N/A",
          no_frost_technology: "N/A",
          defrosting_system: "Manual Defrost",
          noise_level: "N/A",
          anti_odour: "N/A",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "0",
          freezer_tray: "0",
          freezer_drawer: "0",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "-14°C to -18°C",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "PureFresh TMF 250",
        handle: "prism-purefresh-tmf-refrigerator",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "250L",
          total_net_capacity: "197L",
          net_fridge_capacity: "145L",
          net_freezer_capacity: "52L",
          type: "Top Mount",
          product_dimension: "545 x 560 x 1425mm",
          packing_dimension: "575 x 590 x 1469mm",
          net_weight: "40kg",
          gross_weight: "44kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "N/A",
          anti_odour: "Yes",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "2",
          twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_tray: "0",
          freezer_drawer: "0",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "-14°C to -18°C",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Black Inox",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "PureFresh TMF 310",
        handle: "prism-purefresh-tmf-refrigerator",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "310L",
          total_net_capacity: "247L",
          net_fridge_capacity: "195L",
          net_freezer_capacity: "52L",
          type: "Top Mount",
          product_dimension: "545 x 560 x 1670mm",
          packing_dimension: "575 x 607 x 1712mm",
          net_weight: "43kg",
          gross_weight: "47kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "N/A",
          anti_odour: "Yes",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "2",
          twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_tray: "0",
          freezer_drawer: "0",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "-14°C to -18°C",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Black Inox",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "PureFresh TMF 430",
        handle: "prism-purefresh-tmf-refrigerator",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "430L",
          total_net_capacity: "334L",
          net_fridge_capacity: "257L",
          net_freezer_capacity: "77L",
          type: "Top Mount",
          product_dimension: "605 x 670 x 1705mm",
          packing_dimension: "640 x 702 x 1784mm",
          net_weight: "54kg",
          gross_weight: "60kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "N/A",
          anti_odour: "Yes",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "2",
          twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_tray: "0",
          freezer_drawer: "0",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "-14°C to -18°C",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          wheel: "2",
          adjustable_leg: "Yes",
        },
      },
      {
        name: "PureFresh 75L",
        handle: "purefresh-mb-50",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "75L",
          total_net_capacity: "48L",
          net_fridge_capacity: "44L",
          net_freezer_capacity: "Fresh Compartment: 4L",
          type: "Mini Bar",
          product_dimension: "445 X 470 X 501mm",
          packing_dimension: "460 X 500 X 530mm",
          net_weight: "13.3Kg",
          gross_weight: "14.6Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "N/A",
          no_frost_technology: "N/A",
          defrosting_system: "Manual",
          noise_level: "40dB",
          anti_odour: "N/A",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          twist_ice_maker: "Fresh Zone Comparement: 1",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_tray: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "Fresh Zone Compartment: 0°C to -3°C",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Black Inox",
          handle_type: "Recessed",
          wheel: "No",
          adjustable_leg: "2",
        },
      },
      {
        name: "PureFresh 110L",
        handle: "purefresh-mb-90",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "110L",
          total_net_capacity: "91L",
          net_fridge_capacity: "79L",
          net_freezer_capacity: "Fresh Compartment: 12L",
          type: "Mini Bar",
          product_dimension: "445 x 470 x 835mm",
          packing_dimension: "465 x 500 x 880mm",
          net_weight: "19kg",
          gross_weight: "22kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "N/A",
          no_frost_technology: "N/A",
          defrosting_system: "Manual",
          noise_level: "40dB",
          anti_odour: "N/A",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          twist_ice_maker: "Fresh Zone Comparement: 1",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_tray: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          fridge_temperature: "2°C to 8°C",
          freezer_temperature: "Fresh Zone Compartment: 0°C to -3°C",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal",
          colours: "Inox, Black Inox",
          handle_type: "Recessed",
          wheel: "No",
          adjustable_leg: "2",
        },
      },
      {
        name: "FreezeMaster 260",
        handle: "freezemaster",
        image: "//prismplus.my/cdn/shop/files/CFZ2601_1024x1024@2x.png?v=1784786981",
        physical_characteristics: {
          total_gross_capacity: "-",
          total_net_capacity: "198L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          product_dimension: "910 x 550 x 850mm",
          packing_dimension: "934 x 575 x 885mm",
          net_weight: "27kg",
          gross_weight: "31kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "Direct Cooling System",
          defrosting_system: "Manual",
          noise_level: "N/A",
          anti_odour: "N/A",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_tray: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          fridge_temperature: "2°C to -25°C",
          freezer_temperature: "N/A",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal (Foam within), Inner Cavity Pre-Coated White Metal",
          colours: "Light Grey",
          handle_type: "External grip handle",
          wheel: "No",
          adjustable_leg: "02",
        },
      },
      {
        name: "FreezeMaster 390",
        handle: "freezemaster",
        image: "",
        physical_characteristics: {
          total_gross_capacity: "-",
          total_net_capacity: "290L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          product_dimension: "1090 x 615 x 850mm",
          packing_dimension: "1130 x 640 x 885mm",
          net_weight: "36kg",
          gross_weight: "40kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "Direct Cooling System",
          defrosting_system: "Manual",
          noise_level: "N/A",
          anti_odour: "N/A",
          evercool_thermal_panel: "N/A",
          premium_ceramic_air_filter: "N/A",
          voltage: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_tray: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          fridge_temperature: "2°C to -25°C",
          freezer_temperature: "N/A",
          external_led_display: "N/A",
          quick_freeze_mode: "N/A",
          quick_cool_mode: "N/A",
          energy_saving_mode: "N/A",
          lock_mode: "N/A",
        },
        design_build: {
          door_panel_material: "Metal (Foam within), Inner Cavity Pre-Coated White Metal",
          colours: "Light Grey",
          handle_type: "External grip handle",
          wheel: "No",
          adjustable_leg: "02",
        },
      },
    ];

    return data;
  }

  async function getProductData(handle) {
    return await (await fetch(`/products/${handle}.js`)).json();
  }
  
  function assignCssVariables() {
    const comparePopup = $(".compare_fridge_popup")[0];

    setInterval(() => {
      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }
})();
